import { SendRounded } from '@mui/icons-material';
import { CircularProgress, IconButton, InputAdornment, TextField } from '@mui/material';
import { useState } from 'react';

interface IntakeMessageInputProps {
  /**
   * Callback function to send a message
   */
  onSendMessage: (text: string) => void;

  isLoading?: boolean;
  placeholder?: string;
}

export const IntakeStepMessageInput = ({ placeholder, isLoading, onSendMessage }: IntakeMessageInputProps) => {
  const [message, setMessage] = useState('');

  return (
    <TextField
      multiline={true}
      value={message}
      fullWidth
      variant="standard"
      size="medium"
      type="text"
      disabled={isLoading}
      placeholder={placeholder}
      data-intercom-target="Chat Input"
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          onSendMessage(message);
        }
      }}
      onChange={(event) => {
        setMessage(event.target.value);
      }}
      sx={{ borderRadius: 3 }}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                color="primary"
                size="medium"
                onClick={() => {
                  onSendMessage(message);
                }}
                disabled={isLoading || message === ''}
              >
                {isLoading ? <CircularProgress size={24} color="inherit" /> : <SendRounded fontSize="medium" />}
              </IconButton>
            </InputAdornment>
          ),
          sx: { borderRadius: 3 },
        },
      }}
    />
  );
};
